import type {
  BlockStateDefinition,
  ImplicitDependencyGroup,
} from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import type { CheckboxBlockStateType, CheckboxComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';
import type { Action } from '@unifyapps/defs/types/action';
import { getNeoMorphicStyles } from '../Toggle/utils/getNeoMorphicStyles';
import { getResolvedDefaultValue } from '../common/fields/BooleanField/utils/getResolvedDefaultValue';
import Checkbox from './Checkbox';

class CheckboxBlockStateDefinition implements BlockStateDefinition {
  get type(): ComponentTypeUnionType {
    return 'Checkbox';
  }

  getBlockControlMethods() {
    return [
      {
        id: 'setValue',
        label: 'Set Value',
        method: (blockState: CheckboxBlockStateType, action: Action) => {
          const { methodPayload } = action.payload as {
            methodPayload: { value?: unknown };
          };

          const { value } = methodPayload;
          return {
            ...blockState,
            value: getResolvedDefaultValue(value) ?? false,
          };
        },
      },
    ];
  }

  get initialStateGetter() {
    return (block: BlockType) => {
      const blockState = _pick(block.component as CheckboxComponentType, [
        'content',
        'appearance',
        'componentType',
      ]);

      return {
        id: block.id,
        ...blockState,
        appearance: {
          ...blockState.appearance,
          neumorphicStyle: getNeoMorphicStyles(block) as Record<string, unknown>,
        },
      };
    };
  }

  getImplicitDependencyGroups(): ImplicitDependencyGroup {
    return { usingDataSourcesResponse: true };
  }

  getComponent() {
    return Checkbox;
  }
}

export default CheckboxBlockStateDefinition;
